// How long you want the animation to take, in ms
const animationDuration = 2000;
// Calculate how long each ‘frame’ should last if we want to update the animation 60 times per second
const frameDuration = 1000 / 60;
// Use that to calculate how many frames we need to complete the animation
const totalFrames = Math.round( animationDuration / frameDuration );
// An ease-out function that slows the count as it progresses

const EasingFunctions = {
    // no easing, no acceleration
    linear: t => t,
    // accelerating from zero velocity
    easeInQuad: t => t*t,
    // decelerating to zero velocity
    easeOutQuad: t => t*(2-t),
    // acceleration until halfway, then deceleration
    easeInOutQuad: t => t<.5 ? 2*t*t : -1+(4-2*t)*t,
    // accelerating from zero velocity 
    easeInCubic: t => t*t*t,
    // decelerating to zero velocity 
    easeOutCubic: t => (--t)*t*t+1,
    // acceleration until halfway, then deceleration 
    easeInOutCubic: t => t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1,
    // accelerating from zero velocity 
    easeInQuart: t => t*t*t*t,
    // decelerating to zero velocity 
    easeOutQuart: t => 1-(--t)*t*t*t,
    // acceleration until halfway, then deceleration
    easeInOutQuart: t => t<.5 ? 8*t*t*t*t : 1-8*(--t)*t*t*t,
    // accelerating from zero velocity
    easeInQuint: t => t*t*t*t*t,
    // decelerating to zero velocity
    easeOutQuint: t => 1+(--t)*t*t*t*t,
    // acceleration until halfway, then deceleration 
    easeInOutQuint: t => t<.5 ? 16*t*t*t*t*t : 1+16*(--t)*t*t*t*t
  }

// The animation function, which takes an Element
const animateCountUp = (entries, observer) => {
  let formatter = new Intl.NumberFormat( 'en-US' );

  entries.forEach( entry => {
    if (entry.isIntersecting) {
      let el = entry.target;
      observer.unobserve(el);
      
      let frame = 0;

      let isPercentage = el.dataset.target.includes("%");
      let isDollar = el.dataset.target.includes("$");
      let isMillion = el.dataset.target.includes("m") || el.dataset.target.includes("M");
      let hasDecimal =  el.dataset.target.includes(".")

      let countTo = parseFloat( el.dataset.target.replace("M", "").replace("%", "").replace("m", "").replace("$", ""), 10 );
      // Start the animation running 60 times per second
      let counter = setInterval( () => {
        frame++;
        // Calculate our progress as a value between 0 and 1
        // Pass that value to our easing function to get our
        // progress on a curve
        let progress = EasingFunctions.easeOutQuint( frame / totalFrames );
        // Use the progress value to calculate the current count

        let currentCount = 0
        if(hasDecimal)
        {
          currentCount = (countTo * progress).toFixed(1);
        }else{
          currentCount = Math.round( countTo * progress);
        }
    
        // If the current count has changed, update the element
        if ( parseFloat( el.innerHTML.replace("M", "").replace("%", "").replace("m", "").replace("$", ""), 10 ) !== currentCount ) {
          el.innerHTML = (isDollar ? "$" : "") + formatter.format( currentCount ) + (isPercentage ? "%" : "") + (isMillion ? "m" : "");
        }
    
        // If we’ve reached our last frame, stop the animation
        if ( frame === totalFrames ) {
          clearInterval( counter );
        }
      }, frameDuration );
    }
  });
};

const observer = new window.IntersectionObserver(animateCountUp)

// Run the animation on all elements with a class of ‘countup’
const init = () => {
  let countupEls = document.querySelectorAll( '.counter' );
  for (let index = 0; index < countupEls.length; index++) {
    observer.observe(countupEls[index]);   
  }
};

init();
